import ModelCollection from "./ModelCollection"

import Tournament,{E_TOURNAMENT_STATUS} from "./Types/Tournament";

export default class ModelCollectionTournament extends ModelCollection<Tournament>  {
    
    constructor() {
        super();        
    }

    itemDead(game:Tournament) { 
        return game.isDead(); 
    }

    itemCreate(data:object):Tournament { 
        return new Tournament(data);
    }            
}